import { FC } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  height: 560px;
  margin-top: 32px;
  align-items: flex-end;

  overflow: hidden;

  > div {
    width: 328px;
    height: 100%;
    background-size: cover;
    background-position: center center;
    flex-shrink: 0;

    &:not(:last-child) {
      margin-right: 1px;
    }

    &:nth-child(1n) {
      height: ${(100 / 8) * 5.5}%;
    }
    &:nth-child(2n) {
      height: ${(100 / 8) * 5}%;
    }
    &:nth-child(3n) {
      height: ${(100 / 8) * 6}%;
    }
    &:nth-child(4n) {
      height: ${(100 / 8) * 7}%;
    }
    &:nth-child(5n) {
      height: ${(100 / 8) * 8}%;
    }
  }
`;

const ImageTape: FC<{ images?: string[] }> = ({ images }) => {
  return (
    <Style>
      {images ? (
        images.map((x, i) => (
          <div key={`image-tape-${i}`} style={{ backgroundImage: `url('${x}')` }}></div>
        ))
      ) : (
        <>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/grill_tkcw8l.jpg',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/seafood_dn9t5a.png)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/scandinavian_igqsti.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/european_r95itb.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/gastro_sntbjp.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/bistro_o0fryp.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/grill_tkcw8l.jpg',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/scandinavian_igqsti.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/european_r95itb.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/seafood_dn9t5a.png)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/gastro_sntbjp.jpg)',
            }}
          ></div>
          <div
            style={{
              backgroundImage:
                'url(https://res.cloudinary.com/dineout/image/upload/w_750,c_scale/production/static/home/bistro_o0fryp.jpg)',
            }}
          ></div>
        </>
      )}
    </Style>
  );
};

export default ImageTape;
